import {
  BuildingPartCollectionFragment,
  HourSeriesCollectionType,
  HourSeriesFragment,
  ProjectFragment,
} from '../generated/graphql'

export function createHourSeriesNameFormatter(
  project: ProjectFragment,
  buildingParts: BuildingPartCollectionFragment[],
): (hourSeries: HourSeriesFragment) => string {
  const allCollections = [
    ...(project?.hourSeriesCollections ?? []),
    ...buildingParts,
  ]

  const allHourSeries = allCollections.flatMap(
    (collection) => collection.hourSeries,
  )

  const findCollection = (hourSeries: HourSeriesFragment) =>
    allCollections.find((collection) =>
      collection.hourSeries.some(
        (collectionHourSeries) => collectionHourSeries.id === hourSeries.id,
      ),
    )

  return (hourSeries: HourSeriesFragment) => {
    const matchingCollection = findCollection(hourSeries)
    if (!matchingCollection) {
      return hourSeries.name
    }

    if (matchingCollection.type === HourSeriesCollectionType.BuildingPart) {
      return `${hourSeries.name} (${matchingCollection.name})`
    }

    const isDuplicate = allHourSeries.some(
      (h) =>
        h.id !== hourSeries.id &&
        h.name === hourSeries.name &&
        findCollection(h)?.type === matchingCollection.type,
    )

    if (isDuplicate) {
      return `${hourSeries.name} (${matchingCollection.name})`
    }

    return hourSeries.name
  }
}
